import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { SharedService } from "./../../../shared/shared.service";
import { AdminDevoteeService } from './../../services/admin-devotee.service';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.css'],
  providers: [AdminDevoteeService]
})
export class AdminLoginComponent implements OnInit {

  constructor(private sharedService: SharedService,
    private router: Router,
    private adminDevoteeService: AdminDevoteeService) { }

  errorMsg: string = "";
  successMsg: string = "";
  isOTPSend: boolean = false;
  timerMinute: any;
  timerSecond: any;

  ngOnInit() {
    let adminToken = this.sharedService.getAdminTokenAtLocStorage();

    if (adminToken)
      this.router.navigate(["/adminhome"]);
  }

  adminLogin(tokenNo: string): void {
    if (!tokenNo) {
      this.errorMsg = "Please enter token no";
      return;
    }

    this.sharedService.showSpinner();
    this.adminDevoteeService.verifyAdminToken(tokenNo).subscribe(
      data => {
        if (!data) {
          this.errorMsg = "token number is not valid";
          return;
        }
        this.sharedService.setAdminTokenAtLocStorage(tokenNo)

        console.log("AdminLoginSuccess");

        this.router.navigate(["/adminhome"]);
      },
      err => console.log(err),
      () => this.sharedService.hideSpinner()
    )
  }


  sendOTP(mobileNo: string) {
    this.errorMsg = '';
    if (!mobileNo) {
      this.errorMsg = "Please enter mobile no";
      return;
    }

    this.sharedService.showSpinner();
    this.adminDevoteeService.sendOTP(mobileNo).subscribe(
      data => {
        if (!data) {
          this.errorMsg = "There is some error while sending opt, please try after some time.";
          return;
        }
        this.isOTPSend = true;
        this.successMsg = "OTP send"
        this.startOTPTimer(120);
        this.sharedService.hideSpinner()

      },
      err => {
        console.log(err);
        this.errorMsg = err;
        this.sharedService.hideSpinner()
      },
      () => this.sharedService.hideSpinner()
    )
  }

  
  verifyOTP(mobileNo: string, otp: string) {
    this.errorMsg = '';
    if (!mobileNo) {
      this.errorMsg = "Please enter mobile no";
      return;
    }

    this.sharedService.showSpinner();
    this.adminDevoteeService.varifyOTP(mobileNo, otp).subscribe(
      data => {

        if (!data) {
          this.errorMsg = "There is some error while sending opt, please try after some time.";
          return;
        }

        this.sharedService.setAdminTokenAtLocStorage(data.Token);
        
        this.router.navigate(["/adminhome"]);
      },
      err => {
        console.log(err.message);
        this.errorMsg = err.message;
        this.sharedService.hideSpinner()
      },
      () => this.sharedService.hideSpinner()
    )
  }



  startOTPTimer(duration: number) {
    let timer = duration;
    const interval = setInterval(() => {
      this.timerMinute = Math.floor(timer / 60);
      this.timerSecond = timer % 60;

      this.timerMinute = this.timerMinute < 10 ? '0' + this.timerMinute : this.timerMinute;
      this.timerSecond = this.timerSecond < 10 ? '0' + this.timerSecond : this.timerSecond;

      console.log(`Time Remaining: ${this.timerMinute}:${this.timerSecond}`);

      if (--timer < 0) {
        clearInterval(interval);
        this.isOTPSend = false;
        console.log("OTP expired");
      }
    }, 1000);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/admin-login/admin-login.component.ts